<template>
    <div>
        <div v-if="loading"></div>
        <div class="searchBox">
        <div>
          <Multiselect
            v-model="selected"
            placeholder="Catalog Part Number Lookup"
            :options="parts"
            :searchable="true"
            :limit="10"
            :limit-text="limitText"
            :max-height="300"
            :clear-on-select="false"
            :close-on-select="true"
            :hide-selected="false"
            open-direction="bottom"
            @search-change="asyncFind"
            @select="OnCpnSelect"
            :deselectLabel="''"
            >
            <template #noOptions>
              <span v-if="selectedLength<5">Enter 5 or more characters to fetch the cpn list. </span>
            </template>
            <template #noResult>
              <span v-if="isLoading">Loading...</span>
              <span v-else-if="selectedLength>4"> Oops! No elements found. Consider changing the search query.</span>  
              <span v-else>Enter 5 or more characters to fetch the cpn list. </span>
            </template>
            </Multiselect>
        </div>
        </div>   
        <div v-if="isPartExist" class="reportData">
          <div v-if="!isSicCPN">
      <div v-if="dltReliabilityData != null" class="col-md-12 reportHeader">
    <div class="col-md-12 DivTab"><div class="DivTabText">High Temperature Operating Life</div></div>
     
  <div class="col-md-12 marginHeader">
               <div class="row col-md-5 col-sm-12">
                <label class="col-8 labelBackgroundAlt">Test Temperature (C) :</label>
                <div class="col-4 divBackgroundAlt">{{ dltReliabilityData.dltTestTemperature}}</div>
                 </div>
                <div class="row col-md-5 col-sm-12">
                  <label class="col-8 labelBackground" style="padding-right: 5px;">Derated Temperature (C) :</label>
                  <div class="col-4 divBackground"> {{ dltReliabilityData.dltDeratedTemperature}}</div>
                  </div>
                <div class="row col-md-5 col-sm-12">
                  <label class="col-8 labelBackgroundAlt">Activation Energy (eV) :</label>
                  <div class="col-4 divBackgroundAlt">{{ dltReliabilityData.dltActivationEnergy}}</div>
                </div>
                <div class="row col-md-5 col-sm-12">
                  <label class="col-8 labelBackground">Acceleration Factor :</label>
                  <div class="col-4  divBackground">{{ dltReliabilityData.dltAccelerationFactor}}</div>
                   </div>
               </div>
        </div>
    <div class="col-md-12 reportTextAlign">
      <v-data-table   class="table table-sortable" name="dltDetails">
        <template #thead>
            <!-- <thead> -->
        <tr>
          
          <th sortKey="rollingPeriod" class="titlehead">Report Period</th>
            <th sortKey="fails" class="titlehead">Fails</th>
          <th sortKey="deviceHours" class="titlehead">Device Hours</th>
            <th sortKey="fitcl" class="titlehead">FIT @ 60% CL</th>
          <th sortKey="mttFhours" class="titlehead">MTTF (Hours)</th>
        </tr>
      <!-- </thead> -->
        </template>
      
        
     <template #tbody >
        <!-- <tbody class="col-md-12"> -->

          <tr v-for="row in dltReliabilityDetails" :key="row.partNumber">
            
             <td>
              <div class="itemTitle">
                {{ row.rollingPeriod }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.fails }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.deviceHours }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.fitcl }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.mttFhours }}
              </div>
            </td>
          </tr>

          <tr v-if="!bakeReliabilityDetails.length">
            <td colspan="4" class="text-center">No data found.</td>
          </tr>
        <!-- </tbody> -->
     </template>
     <template #no-data>
            
    </template>
     <template #bottom></template>
    
      </v-data-table>
    </div>
       <div v-if="bakeReliabilityData != null" class="col-md-12">
     <div class="col-md-12 DivTab"><div class="DivTabText">Retention Bake</div></div>
   
  <div class="col-md-12 marginHeader">
               <div class="row col-md-5 col-sm-12">
                <label class="col-8 labelBackgroundAlt">Bake Temperature (C) :</label>
                <div class="col-4 divBackgroundAlt">{{ bakeReliabilityData.bakeTemperature}}</div>
                 </div>
               <div class="row col-md-5 col-sm-12">
                  <label class="col-8 labelBackground" style="padding-right: 0px;">Derated Temperature (C) :</label>
                  <div class="col-4 divBackground"> {{ bakeReliabilityData.bakeDeratedTemperature}}</div>
                  </div>
                <div class="row col-md-5 col-sm-12">
                  <label class="col-8 labelBackgroundAlt">Activation Energy (eV) :</label>
                  <div class="col-4 divBackgroundAlt">{{ bakeReliabilityData.bakeActivationEnergy}}</div>
                </div>
                <div class="row col-md-5 col-sm-12">
                  <label class="col-8 labelBackground">Acceleration Factor :</label>
                  <div class="col-4 divBackground">{{ bakeReliabilityData.bakeAccelerationFactor}}</div>
                   </div>
               </div>
         </div>     

   
    <div class="col-md-12 reportTextAlign">
      <v-data-table  class="table table-sortable" name="bakeDetails">
        <template #thead>
        <tr>
         
          <th sortKey="Report Period" class="titlehead">Report Period</th>
          <th sortKey="Fails" class="titlehead">Fails</th>
          <th sortKey="Device Hours" class="titlehead">Device Hours</th>
          <th sortKey="FIT @ 60% CL" class="titlehead">FIT @ 60% CL</th>
          <th sortKey="MTTF (Hours)" class="titlehead">MTTF (Hours)</th>
        </tr>
      <!-- </thead> -->
        </template>
        <template #tbody>
          <tr v-for="row in bakeReliabilityDetails" :key="row.partNumber">
            
             <td>
              <div class="itemTitle">
                {{ row.rollingPeriod }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.fails }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.deviceHours }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.fitcl }}
              </div>
            </td>
            <td>
              <div class="itemTitle">
                {{ row.mttFhours }}
              </div>
            </td>
        
          </tr>
          
          <tr v-if="!bakeReliabilityDetails.length">
            <td colspan="4" class="text-center">No data found.</td>
        </tr>
        </template>
        <template #no-data>

        </template>
     <template #bottom></template>
       
      </v-data-table>
    </div>
        </div>  
        <div v-else>
          <div v-if="hasSectionData(reliabilitySICDetails, ['htgbTestTempC', 'htgbActivationEnergyEv', 'htgbafThermalDeratedT55C', 'htgbCumFails', 'htgbCumDeviceHours', 'htgbCumFIT', 'htgbCumMTTFHours'])">
        <div class="col-md-12 reportHeader">
          <div class="col-md-12 DivTab">
            <div class="DivTabText">High Temperature Gate Bias</div>
          </div>

          <div class="col-md-12 marginHeader">
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackgroundAlt">Test Temperature (C) :</label>
              <div class="col-4 divBackgroundAlt">{{ reliabilitySICDetails[0].htgbTestTempC }}</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackground" style="padding-right: 5px;">Derated Temperature (C) :</label>
              <div class="col-4 divBackground"> 25</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackgroundAlt">Activation Energy (eV) :</label>
              <div class="col-4 divBackgroundAlt">{{ reliabilitySICDetails[0].htgbActivationEnergyEv }}</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackground">Acceleration Factor :</label>
              <div class="col-4  divBackground">{{ reliabilitySICDetails[0].htgbafThermalDeratedT55C }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-12 reportTextAlign">
          <v-data-table class="table table-sortable" name="gateBiasDetails">
            <template #thead>
              <!-- <thead> -->
              <tr>

                <th sortKey="rollingPeriod" class="titlehead">Report Period</th>
                <th sortKey="fails" class="titlehead">Fails</th>
                <th sortKey="deviceHours" class="titlehead">Device Hours</th>
                <th sortKey="fitcl" class="titlehead">FIT @ 60% CL</th>
                <th sortKey="mttFhours" class="titlehead">MTTF (Hours)</th>
              </tr>
              <!-- </thead> -->
            </template>


            <template #tbody>
              <!-- <tbody class="col-md-12"> -->

              <tr v-for="row in reliabilitySICDetails" :key="row.partNumber">

                <td>
                  <div class="itemTitle">
                    Cumulative
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htgbCumFails }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htgbCumDeviceHours }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htgbCumFIT }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htgbCumMTTFHours }}
                  </div>
                </td>
              </tr>

              <tr v-if="!hasSectionData(reliabilitySICDetails, ['htgbCumFails', 'htgbCumDeviceHours', 'htgbCumFIT', 'htgbCumMTTFHours'])">
                <td colspan="5" class="text-center">No data found.</td>
              </tr>
            </template>
            <template #no-data>

            </template>
            <template #bottom></template>

          </v-data-table>
        </div>
      </div>
      <div v-if="hasSectionData(reliabilitySICDetails, ['htrbTestTempC', 'htrbActivationEnergyEv', 'htrbafThermalDeratedT25C', 'htrbCumFails', 'htrbCumDeviceHours', 'htrbCumFIT', 'htrbCumMTTFHours'])">
        <div class="col-md-12 reportHeader">
          <div class="col-md-12 DivTab">
            <div class="DivTabText">High Temperature Reverse Bias</div>
          </div>

          <div class="col-md-12 marginHeader">
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackgroundAlt">Test Temperature (C) :</label>
              <div class="col-4 divBackgroundAlt">{{ reliabilitySICDetails[0].htrbTestTempC }}</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackground" style="padding-right: 5px;">Derated Temperature (C) :</label>
              <div class="col-4 divBackground"> 25</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackgroundAlt">Activation Energy (eV) :</label>
              <div class="col-4 divBackgroundAlt">{{ reliabilitySICDetails[0].htrbActivationEnergyEv }}</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackground">Acceleration Factor :</label>
              <div class="col-4  divBackground">{{ reliabilitySICDetails[0].htrbafThermalDeratedT25C }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-12 reportTextAlign">
          <v-data-table class="table table-sortable" name="reverseBiasDetails">
            <template #thead>
              <!-- <thead> -->
              <tr>

                <th sortKey="rollingPeriod" class="titlehead">Report Period</th>
                <th sortKey="fails" class="titlehead">Fails</th>
                <th sortKey="deviceHours" class="titlehead">Device Hours</th>
                <th sortKey="fitcl" class="titlehead">FIT @ 60% CL</th>
                <th sortKey="mttFhours" class="titlehead">MTTF (Hours)</th>
              </tr>
              <!-- </thead> -->
            </template>


            <template #tbody>
              <!-- <tbody class="col-md-12"> -->

              <tr v-for="row in reliabilitySICDetails" :key="row.partNumber">

                <td>
                  <div class="itemTitle">
                    Cumulative
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htrbCumFails }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htrbCumDeviceHours }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htrbCumFIT }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.htrbCumMTTFHours }}
                  </div>
                </td>
              </tr>

              <tr v-if="!hasSectionData(reliabilitySICDetails, ['htrbCumFails', 'htrbCumDeviceHours', 'htrbCumFIT', 'htrbCumMTTFHours'])">
                <td colspan="5" class="text-center">No data found.</td>
              </tr>
              <!-- </tbody> -->
            </template>
            <template #no-data>

            </template>
            <template #bottom></template>

          </v-data-table>
        </div>
      </div>
      <div v-if="hasSectionData(reliabilitySICDetails, ['nhtgbTestTempC', 'nhtgbActivationEnergyEv', 'nhtgbafThermalDeratedT25C', 'nhtgbCumFails', 'nhtgbCumDeviceHours', 'nhtgbCumFIT', 'nhtgbCumMTTFHours'])">
        <div class="col-md-12 reportHeader">
          <div class="col-md-12 DivTab">
            <div class="DivTabText">Negative High Temperature Gate Bias</div>
          </div>

          <div class="col-md-12 marginHeader">
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackgroundAlt">Test Temperature (C) :</label>
              <div class="col-4 divBackgroundAlt">{{ reliabilitySICDetails[0].nhtgbTestTempC }}</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackground" style="padding-right: 5px;">Derated Temperature (C) :</label>
              <div class="col-4 divBackground"> 25</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackgroundAlt">Activation Energy (eV) :</label>
              <div class="col-4 divBackgroundAlt">{{ reliabilitySICDetails[0].nhtgbActivationEnergyEv }}</div>
            </div>
            <div class="row col-md-5 col-sm-12">
              <label class="col-8 labelBackground">Acceleration Factor :</label>
              <div class="col-4  divBackground">{{ reliabilitySICDetails[0].nhtgbafThermalDeratedT25C }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-12 reportTextAlign">
          <v-data-table class="table table-sortable" name="negativeGateBiasDetails">
            <template #thead>
              <!-- <thead> -->
              <tr>

                <th sortKey="rollingPeriod" class="titlehead">Report Period</th>
                <th sortKey="fails" class="titlehead">Fails</th>
                <th sortKey="deviceHours" class="titlehead">Device Hours</th>
                <th sortKey="fitcl" class="titlehead">FIT @ 60% CL</th>
                <th sortKey="mttFhours" class="titlehead">MTTF (Hours)</th>
              </tr>
              <!-- </thead> -->
            </template>


            <template #tbody>
              <!-- <tbody class="col-md-12"> -->

              <tr v-for="row in reliabilitySICDetails" :key="row.partNumber">

                <td>
                  <div class="itemTitle">
                    Cumulative
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.nhtgbCumFails }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.nhtgbCumDeviceHours }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.nhtgbCumFIT }}
                  </div>
                </td>
                <td>
                  <div class="itemTitle">
                    {{ row.nhtgbCumMTTFHours }}
                  </div>
                </td>
              </tr>

              <tr v-if="!hasSectionData(reliabilitySICDetails, ['nhtgbCumFails', 'nhtgbCumDeviceHours', 'nhtgbCumFIT', 'nhtgbCumMTTFHours'])">
                <td colspan="5" class="text-center">No data found.</td>
              </tr>
              <!-- </tbody> -->
            </template>
            <template #no-data>

            </template>
            <template #bottom></template>

          </v-data-table>
        </div>
      </div>
        </div>
        </div>
    </div>

</template>



<script>
import Multiselect from "vue-multiselect";
import GetReliabilityData from "../../api/realibilityReport";
const Swal=require("sweetalert2");

export default{
    name:"ReliabilityReport",
    components:{
      Multiselect
    },
    data(){
        return{
        myReliabilityReports:[],
       filters: {
        name: { value: "", keys: ["title"] },
       },
       selected: null,
       selectedLength:0,
       Category: null,
       options: [],
       selectedPart:null,
       parts:[],
       userName: "",
       isLoading:false,
       currentPage: 1,
       totalPages: 0,
       loading: false,
      loggedUserID: "",
      isPartNumber:false,
      isPartExist:false,
      isDltDataExist:false,
      isBakeDataExist:false,
      partNumbers:[],
      reliabilityData:[],
      SelectedProduct:"",
      partNumber1:"PIC10F200/SD01",
      partNumber:"",
      dltReliabilityData:[],
      bakeReliabilityData:[],
      dltReliabilityDetails:[],
      bakeReliabilityDetails:[],
      isDevice:false,
      isSicCPN:false,
      reliabilitySICDetails:[],
      displayData: [
      {
        "Process": "16XK",
        "ReportPeriod": "Since year 2017",
        "Fails": 3,
        "DeviceHours": 8155848,
        "FIT": 2.0,
        "MTTF": 508571297
      },
      {
        "Process": "16XK",
        "ReportPeriod": "Cumulative",
        "Fails": 14,
        "DeviceHours": 43956168,
        "FIT": 1.4,
        "MTTF": 730889907
      }
    ],
     }},
    mounted(){
      if(this.$route.params.cpn){
        this.selected=this.$route.params.cpn;
        this.GetProducts(this.selected.substring(0, 5));
        this.OpenReliabilityReportData();
      }
        this.loading=true;
    },
    methods:{
        clearAll(){
            this.parts=[]
        },
        GetProducts(query){
          let vm=this;
            let repo=[];
            const swalWithValidations=Swal.mixin({
                type: "error",
                title: "Oops...",
            });
            let isLastChar;
            GetReliabilityData.GetReliabilityCPNList(query)
            .then(function(res){
                if(res.length>0){
                    for(var i=0;i<res.length;i++){
                        repo[repo.length]=res[i];
                    }
                    vm.isDevice=false;
                }else if(query.length==5 && res.length==0){
                    isLastChar=true;
                    swalWithValidations.fire({
                        html:"<br />The reliability information (MTBF, FIT, etc.) for your requested device is not available via this tool at this time. Please check that the requested catalog part number is correct. To request data missing from this tool, please follow the instructions below.<br /><br />   Please follow these instructions to begin this process:   <br />1. Contact your local <a href='https://www.microchip.com/salesdirectory' style='cursor: pointer;color:#da291c;text-decoration: underline;'>Microchip sales office</a> to request a Non-Standard Customer Action Request (NSCAR) and explain the type of data that you need for your device.   <br />2. If you are unsuccessful in reaching someone in the local Microchip sales office, please create a <a href='http://support.microchip.com/' style='cursor: pointer;color:#da291c;text-decoration: underline;'>support ticket</a>. Our support engineers will then facilitate communication between you and your local sales office."
                    });
                    vm.isPartExist=false;
                }else if(query.length>5 && repo.length==0 && isLastChar==false){
                    isLastChar=true;
                    swalWithValidations.fire({
                        html: "<br />The reliability information (MTBF, FIT, etc.) for your requested device is not available via this tool at this time. Please check that the requested catalog part number is correct. To request data missing from this tool, please follow the instructions below.<br /><br />   Please follow these instructions to begin this process:   <br />1. Contact your local <a href='https://www.microchip.com/salesdirectory' style='cursor: pointer;color:#da291c;text-decoration: underline;'>Microchip sales office</a> to request a Non-Standard Customer Action Request (NSCAR) and explain the type of data that you need for your device.   <br />2. If you are unsuccessful in reaching someone in the local Microchip sales office, please create a <a href='http://support.microchip.com/' style='cursor: pointer;color:#da291c;text-decoration: underline;'>support ticket</a>. Our support engineers will then facilitate communication between you and your local sales office."
                    });
                    vm.isPartExist=false;
                }
                vm.parts=repo;
            })
            .catch((err)=>{
                console.log(err)
            })
        },
        asyncFind (query) {
            this.selectedLength=query.trim().length;
            if (this.selectedLength === 0) {
                return null
            }
            if(this.selectedLength>4){
                this.GetProducts(query);
            }
        },
        ValidatePart(query){
            alert("wertu");
            if(this.isDevice){
                const swalWithValidations = Swal.mixin({
                type: "error",
                title: "Oops...",
                });

                swalWithValidations.fire({
                html: "<br />The reliability information (MTBF, FIT, etc.) for your requested device is not available via this tool at this time. Please check that the requested catalog part number is correct. To request data missing from this tool, please follow the instructions below.<br /><br />   Please follow these instructions to begin this process:   <br />1. Contact your local <a href='https://www.microchip.com/salesdirectory' style='cursor: pointer;color:#da291c;text-decoration: underline;'>Microchip sales office</a> to request a Non-Standard Customer Action Request (NSCAR) and explain the type of data that you need for your device.   <br />2. If you are unsuccessful in reaching someone in the local Microchip sales office, please create a <a href='http://support.microchip.com/' style='cursor: pointer;color:#da291c;text-decoration: underline;'>support ticket</a>. Our support engineers will then facilitate communication between you and your local sales office."
                });
            }
        },
        limitText(count){
           return `and ${count} other partNumbers`
        },
        hasValue(value){
          return value !== null && value !== undefined && value !== '';
        },
        hasSectionData(rows, fields){
          if(!Array.isArray(rows) || rows.length === 0){
            return false;
          }

          return rows.some((row) => fields.some((field) => this.hasValue(row && row[field])));
        },
       OnCpnSelect(){
        this.$router.push({ name: 'ReliabalityReportByCpn', params: { cpn: this.selected } });
          this.OpenReliabilityReportData();
       },
        OpenReliabilityReportData(){
            const vm=this;
            const swalWithValidations=Swal.mixin({
                type:"error",
                title:"Oops..."
            });
            vm.selectedPart=vm.selected;
            GetReliabilityData.GetReliabilityReportDataByCPN(this.selected)
            .then(function(res){
                vm.reliabilityData=res;
                const hasDltData = res != null && Object.keys(res).length > 0 && res.dltHeaderDetails != null;
                const hasSicData = res != null && Object.keys(res).length > 0 && Array.isArray(res.reliabilitySICDetails) && res.reliabilitySICDetails.length > 0;
                if (hasDltData || hasSicData){
                  vm.isSicCPN=res.isSicCPN;
                  if(vm.isSicCPN){
                  vm.reliabilitySICDetails=res.reliabilitySICDetails;
                    }else{
                    vm.dltReliabilityData= res.dltHeaderDetails;
                    vm.bakeReliabilityData= res.bakeHeaderDetails;
                    vm.dltReliabilityDetails= res.dltDataDetails;
                    vm.bakeReliabilityDetails = res.bakeDataDetails;
                    }
                    vm.isPartExist=true;
                    }
                    else{
                        swalWithValidations.fire({
                            html: "<br />The reliability information (MTBF, FIT, etc.) for your requested device is not available via this tool at this time. Please check that the requested catalog part number is correct. To request data missing from this tool, please follow the instructions below.<br /><br />   Please follow these instructions to begin this process:   <br />1. Contact your local <a href='https://www.microchip.com/salesdirectory' style='cursor: pointer;color:#da291c;text-decoration: underline;'>Microchip sales office</a> to request a Non-Standard Customer Action Request (NSCAR) and explain the type of data that you need for your device.   <br />2. If you are unsuccessful in reaching someone in the local Microchip sales office, please create a <a href='http://support.microchip.com/' style='cursor: pointer;color:#da291c;text-decoration: underline;'>support ticket</a>. Our support engineers will then facilitate communication between you and your local sales office."
                        });
                        vm.isPartExist=false;
                                      // swalWithValidations.fire({
                                      //   text:"The",
                                      //      html: "The reliability information (MTBF, FIT, etc.) for your requested device is not available via this tool at this time. Please check that the requested catalog part number is correct. To request data missing from this tool, please follow the instructions below.<br />  Please follow these instructions to begin this process:   <br />1. Contact your local <a href='https://www.microchip.com/salesdirectory' style='cursor: pointer;color:#da291c;text-decoration: underline;'>Microchip sales office</a> to request a Non-Standard Customer Action Request (NSCAR) and explain the type of data that you need for your device.   <br />2. If you are unsuccessful in reaching someone in the local Microchip sales office, please create a <a href='http://support.microchip.com/' style='cursor: pointer;color:#da291c;text-decoration: underline;'>support ticket</a>. Our support engineers will then facilitate communication between you and your local sales office."
                                      //  });
                    }
            })
            .catch((err)=>{
                console.log(err);
                swalWithValidations.fire({
                    text:"There is an Error getting the details for device -" + this.selected 
                });
            });
        }
    }
}
</script>


<style scoped>
.reportData{
    width:100%;
    font-family:'Open Sans',sans-serif;
    font-size: 15px !important;
    padding-inline:calc(2% + 85px);
}
.titlehead {
  width: 10%;
  cursor: default;
  background-color: #e4ecf1;
  color:#1C355E;
  font-weight: 600;
}
.no-data-text {
  margin: 168px 0px;
}

.aligncenter{
  align-items: center;
    text-align: center;
    padding-bottom: 15px;
}
.row{
    margin: 0;
}
tr{
    border: none;
}
.column {
  float: left;
  width: 47%;
  padding: 5px;
}

/* Clearfix (clear floats) */
.row::after {
  content: "";
  clear: both;
  display: table;
}
table{
  min-width: 600px !important;
}

tbody{
    border: 0;
}
th, td {
  text-align: left;
  padding: 16px;
}

tr:nth-child(odd) {
  background-color: #f9f9f9;
}

thead{
    width: 100%;
}
.searchBar
{
  margin-left: 20%;
    margin-right: 20%;
  
}
.DivTab 
{
    overflow: hidden;
    padding: 6px 8px;
   border-bottom:1px solid #1c355e;
    margin-bottom: 10px;
}

.labelBackgroundAlt{
    padding: 10px;
    padding-top: 10px;
    margin-bottom: 7px; 
    margin-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 0px;
     border-bottom: #e9e9e6 1px solid;
    padding-bottom: 5px;
}

.divBackgroundAlt{
    margin-right: 0; 
    padding-top: 10px;
       margin-top: 0px;   
    padding-bottom: 5px;
    border-bottom: #e9e9e6 1px solid;
}
.labelBackground{
    padding: 10px;
    padding-top: 10px;
    margin-bottom: 7px; 
    margin-top: 0px;
    padding-bottom: 0px;
    margin-bottom: 0px;
        border-bottom: #e9e9e6 1px solid;
    padding-bottom: 5px;
}
.divBackground{
    margin-right: 0; 
    padding-top: 10px;
       margin-top: 0px;
    padding-bottom: 5px;
    border-bottom: #e9e9e6 1px solid;
}
.marginHeader{
    margin-top: 0px;
    margin-bottom: 10px;
}
.DivTabText{
    font-weight:600;
    font-size:15px;
    margin-left:10px;
    color:#1C355E;
}
  @media only screen and (max-width:768px) {
    .reportData,.searchBox,.divHeader{
      padding-inline: 24px !important;
    }
}
::v-deep .v-data-table-rows-no-data {
        display: none;
    }

 .table{
    margin-top:30px;
    font-size: 15px;
     }

    
</style>
